import React from "react"
import "./Date.scss"
import moment from "moment"
import Images from "../../UI/Image/Image"
import { selectIcon, SVG } from "../../UI/selector"
import SortIcon from "../SortIcon/SortIcon"
import { CheckValue } from "../../../services/CommonFunction"
import ToolTips from "../ToolTips/ToolTips"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons"

const DateText = (props) => {
  return (
    <p className="dates">
      <span>
        <We {...props} /> <Da {...props} /> <Mo {...props} /> <Ti {...props} />
      </span>
      <span>Duration - {props.duration || "0 Min"}</span>
    </p>
  )
}

export const Durations = (props) => {
  return (
    <p className={`dates ${props.className || ""}`}>
      <span>{props.duration || "0 Min"}</span>
    </p>
  )
}

export const DurationsTable = (props) => {
  return (
    <p className={`dates_table ${props.className || ""}`}>
      <span>{props.duration || "0 Min"}</span>
    </p>
  )
}

export const TableDurations = (props) => {
  return (
    <p className={`table_duration font12 ${props.className}`}>
      <span>{props.duration || 0}</span>
    </p>
  )
}

export const TableLogo = (props) => {
  return (
    <p className={`table_logo ${props.className}`}>
      <Images class="logo_img" src={props.logo} />
    </p>
  )
}

export const DateList = (props) => {
  return (
    <p className="date">
      <span>
        <We {...props} /> <Da {...props} /> <Mo {...props} /> <Ti {...props} />
      </span>
      {props.duration !== null && !props.user.ondemandVideoStatus ? (
        <span>Duration - {props.duration || 0}</span>
      ) : null}
    </p>
  )
}

const DateWithFormat = (props) => {
  return (
    <p className="dates">
      <span>
        {CheckValue(props.date)
          ? moment(props.date).format(props.format)
          : "- - -"}
      </span>
    </p>
  )
}

export const DateWithFormatTable = (props) => {
  return (
    <React.Fragment>
      {CheckValue(props.date)
        ? moment(props.date).format(props.format || "ddd Do MMMM YYYY")
        : "- - -"}
    </React.Fragment>
    // <p className="dates_table">
    // </p>
  )
}

const DateWithTextFormat = (props) => {
  return (
    <p className="dates">
      <span>
        {props.dateText} -{" "}
        {props.date ? moment(props.date).format(props.format) : "- - -"}
      </span>
    </p>
  )
}

const DateTitle = (props) => {
  return (
    <p className={`dates ${props.className || ""}`}>
      {props.sort ? (
        <SortIcon
          ascDesc={props.duration}
          keys="duration"
          ascDescClick={props.ascDescClick}
        />
      ) : null}
      <span>{props.title || ""}</span>
    </p>
  )
}

export const DateTitles = (props) => {
  return (
    <span>
      {props.sort ? (
        <SortIcon
          ascDesc={props.value}
          keys={props.status}
          ascDescClick={props.ascDescClick}
        />
      ) : null}
      <span>{props.title || ""}</span>
    </span>
  )
}

export const DurationTitle = (props) => {
  return (
    <p className={`${props.className}`}>
      <span>
        {props.title || ""}
        {props.info ? (
          <ToolTips showTooltip={true} position="right" message={props.info}>
            <FontAwesomeIcon className="info_icon" icon={faInfoCircle} />
          </ToolTips>
        ) : null}
      </span>
    </p>
  )
}

const AddedDate = (props) => {
  return (
    <p className="dates">
      {/* <span> {props.text || 'Added On'} - <We {...props} /> <Da {...props} /> <Mo {...props} /></span> */}
      <span>
        {" "}
        <We {...props} /> <Da {...props} /> <Mo {...props} />
      </span>
    </p>
  )
}

const selectDate = (value) => {
  switch (value) {
    case 1:
      return "st"
    case 2:
      return "nd"
    case 3:
      return "rd"
    default:
      return "th"
  }
}

// const Ye = (props) => { return (
//     new Intl.DateTimeFormat('en', { year: 'numeric' }).format(props.date?new Date(props.date): new Date())
//     )
// }

const We = (props) => {
  return new Intl.DateTimeFormat("en", { weekday: "short" }).format(
    props.date ? new Date(props.date) : new Date()
  )
}

const Mo = (props) => {
  return new Intl.DateTimeFormat("en", { month: "long" }).format(
    props.date ? new Date(props.date) : new Date()
  )
}
const Ti = (props) => {
  return new Intl.DateTimeFormat("en", {
    hour: "numeric",
    minute: "2-digit",
  }).format(props.date ? new Date(props.date) : new Date())
}

const Da = (props) => {
  let date = props.date ? new Date(props.date) : new Date()
  let number = date.getDate() % 10
  return (
    <React.Fragment>
      {new Intl.DateTimeFormat("en", { day: "numeric" }).format(
        props.date ? new Date(props.date) : new Date()
      )}
      {selectDate(number)}
    </React.Fragment>
  )
}

export { DateText, AddedDate, DateWithFormat, DateTitle, DateWithTextFormat }
